import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  ApiFilterOperation,
  DetailContext,
  DetailMode,
  FormCustomField,
  FormDictionaryField,
  TextField,
  useFormSelector,
} from '@eas/common-web';
import { Redirect } from '@composite/redirect/redirect';
import { dictionaryFieldLabelMapper } from '@components/form/misc/label-mappers';
import { CourtFile, PlenaryOpinionFile } from '@models';
import { Agenda, EvidenceBrowserUrl, UIElement } from '@enums';
import { useEsFileListSource, useEsFiles } from '../../../es-file/es-file-api';
import { usePlenaryOpinionPermission } from '../../../es-file/es-file-permission';
import {
  useCourtFileColumns,
  useCourtFileFilterColumns,
} from '../../plenary-opinion-file-columns';

export const CourtFileField = ({ courtFile }: { courtFile: CourtFile }) => (
  <div style={{ display: 'flex' }}>
    <TextField value={courtFile.number?.value} disabled={true} />
    <Redirect url={EvidenceBrowserUrl.ES_FILES_ALL} id={courtFile.id} />
  </div>
);

export function SourceFileField() {
  const { mode, source } = useContext(DetailContext);

  const { sourceFiles } = useFormSelector((data: PlenaryOpinionFile) => ({
    sourceFiles: data.sourceFiles,
  }));

  const courtFileColumns = useCourtFileColumns();
  const filters = useCourtFileFilterColumns();

  const courtFileFilters = [
    {
      field: 'agenda.id',
      operation: ApiFilterOperation.EQ,
      value: Agenda.COURT,
    },
    {
      field: 'number',
      operation: ApiFilterOperation.NOT_NULL,
    },
    {
      operation: ApiFilterOperation.NOT,
      filters: [
        {
          field: 'state.id',
          operation: ApiFilterOperation.EQ,
          value: 'REGISTRY',
        },
      ],
    },
  ];
  const courtFileDialogSource = useEsFileListSource();
  const courtFileAutocompleteSource = useEsFiles({
    filters: courtFileFilters,
  });

  const { hasPermission } = usePlenaryOpinionPermission(source.data);

  return (
    <>
      {[DetailMode.EDIT, DetailMode.NEW].includes(mode) && (
        <FormDictionaryField
          name="sourceFiles"
          label={
            <FormattedMessage
              id="ES__PLENARY_OPINION_FILES__DETAIL__FIELD_LABEL__SOURCE_FILES"
              defaultMessage="Zdrojové spisové značky"
            />
          }
          dialogSource={courtFileDialogSource}
          autocompleteSource={courtFileAutocompleteSource}
          multiple={true}
          dialogPreFilters={courtFileFilters}
          columns={courtFileColumns}
          filters={filters}
          maxRows={9}
          labelMapper={dictionaryFieldLabelMapper}
          disabled={!hasPermission(UIElement.PlenaryOpinionFile.SOURCE_FILES)}
        />
      )}
      {mode === DetailMode.VIEW && (
        <FormCustomField
          name="sourceFiles"
          style={{ flexDirection: 'column' }}
          label={
            <FormattedMessage
              id="ES__PLENARY_OPINION_FILES__DETAIL__FIELD_LABEL__SOURCE_FILES"
              defaultMessage="Zdrojové spisové značky"
            />
          }
        >
          <div>
            {sourceFiles?.map((sourceFile) => (
              <CourtFileField courtFile={sourceFile} key={sourceFile.id} />
            ))}
          </div>
        </FormCustomField>
      )}
    </>
  );
}
